module.exports = __webpack_public_path__ + "static/media/Flashbang-Rafiki-cards_spades-4.92bbdc8a.svg";